import { getNetworkedEntity } from "../utils/scene-graph";

AFRAME.registerComponent("inspect-button", {
  schema: {
    disableOnMobile: { default: false }
  },
  init() {
    this.isMobileVR = AFRAME.utils.device.isMobileVR();

    if (this.data.disableOnMobile && this.isMobileVR) {
      this.el.remove();
      return;
    }

    this.targetEl = null;
    this.video = null;

    getNetworkedEntity(this.el).then(networkedEl => {
      this.targetEl = networkedEl;
      this.video = this.targetEl.components["media-video"];
    });
  },

  isVideoTarget() {
    return this.targetEl && this.targetEl.components["media-video"];
  },

  inspectVideo() {
    if (this.isVideoTarget() && !this.isMobileVR) {
      this.targetEl.components["media-video"].inspect();
      return true;
    }
    return false;
  },

  tick() {
    if (!this.initializedInTick) {
      // initialize in tick so that parent's `tags` component has been initialized
      this.initializedInTick = true;
      this.el.object3D.addEventListener("holdable-button-down", () => {
        if (this.inspectVideo()) return;
        this.el.sceneEl.systems["hubs-systems"].cameraSystem.inspect(this.targetEl, 1.5);
      });
      this.el.object3D.addEventListener("holdable-button-up", () => {
        if (this.isVideoTarget() && !this.isMobileVR) return;
        this.el.sceneEl.systems["hubs-systems"].cameraSystem.uninspect();
      });
    }
  }
});
